import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['status'];

  static values = { text: String, name: String };

  // action="clipboard-copy#copy"
  async copy() {
    // 値の一部をドラッグ選択したときも mouseup で click が飛ぶ。
    // そのままコピーすると選択範囲を無視して全体で上書きしてしまうので、
    // この要素の中に選択範囲があるときは何もしない
    const selection = window.getSelection();
    if (!selection.isCollapsed && this.element.contains(selection.anchorNode))
      return;

    try {
      await navigator.clipboard.writeText(this.textValue);
      this.#notify('success', `${this.nameValue}をコピーしました`);
    } catch {
      // navigator.clipboard は非セキュアコンテキストでは未定義。権限拒否で reject することもある
      this.#notify('error', `${this.nameValue}をコピーできませんでした`);
    }
  }

  #notify(type, message) {
    // alertify は文字列を渡すと innerHTML で描画する。name にユーザー入力由来の値が
    // 渡されても HTML として解釈されないよう、要素を組み立てて渡す
    const content = document.createElement('span');
    content.textContent = message;
    alertify[type](content);

    // alertify の通知には live region が無いため、支援技術にはこちらで伝える
    this.statusTarget.textContent = message;
  }
}
